export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const GET_API_URLS = {
  GET_LOCATION: "/api/canco/store/",
  GET_CARDS: "/api/canco_loyalty/cards/",
  GET_CARD_TRANSACTION: "/api/canco_loyalty/cards/",
  GET_USER_DETAIL: "/api/accounts/user/",
  GET_CITIES: "/api/canco/city/",
  GET_PROVINCE: "/api/canco/province/",
  GET_BLOG: "/api/cancoblog/",
  GET_BANNER: "/api/canco/banner/",
  GET_PROMOTIONS: "/api/webpromotions/web_promotions",
  GET_MOBILE_APP_VERSION: "/api/canco/mobile-app-version/",
};

export const POST_API_URLS = {
  ACKROO_LOGIN: "/api/accounts/login/",
  REGISTER_USER: "/api/accounts/register/",
  RESET_PASSWORD: "/api/accounts/reset_password/",
  NEW_PASSWORD: "/api/accounts/reset_password/confirm/",
  ADD_CARD: "/api/canco_loyalty/cards/",
  BALANCE_TRANSFER: "/api/canco_loyalty/cards/transfer/",
  VENDOR_FORM: "/api/userforms/vendorforms/",
  FLEET_CARD_MEMBER_FORM: "/api/userforms/fleetcards/",
  CONTACT_FORM: "/api/userforms/contact_us/",
  SURVEY_FORM: "/api/userforms/surveys/",
  UNREGISTER_USER: "/api/userforms/unregister-canco-user/",
  SPIRIT_FORM: "/api/contests/schoolspirit/submit/",
  MISSING_POINT_FORM: "/api/ContactFormMissingPoints",
  REALTOR_FORM: "/api/userforms/realtorforms/",
  DEALER_FORM: "/api/userforms/dealer-intake/",
  RETAIL_AGENT_FORM: "/api/userforms/agent-intake/",
  WHOLESALE_BUSINESS_FORM: "/api/userforms/business-contact-us/",
  XPRESS_CARDLOCK_APPLICATION: "/api/userforms/xpress-card-application/",
};
